// Importar esse arquivo no main.js
const ReactiveSearch = {
  timeoutId: null,

  handleAutocomplete: async function(_term){
    const response = await fetch(`/busca?q=${_term}&v=${Math.random()}`, {
      headers: {
        'Content-type': 'application/json',
        accept: 'application/json',
        cache: 'no-store',
      },
    });
  
    ReactiveSearch.handlePopulate(await response.json());
  },

  handlePopulate: function(_response){
    let searchResult = "";
    const close = document.querySelector('[data-close-reactive-search]');
    const search = document.querySelector('[data-reactive-search]');
    const resultContainer = document.querySelector('[data-search-result]');

    resultContainer.classList.add('-loading');

    if (_response.length > 0) {
      _response.forEach((product)=>{
        searchResult += `
        <a href="${product.url}" class="product-item" data-product-box="${product.id}">
          <div class="product-image image -square">
            <img src="${product.image_url}">
          </div>
          <div class="product-text">
            <h3>${product.name}</h3>
            <div class="price-wrapper">
              <div class="product-price" data-update-price="${product.id}"></div>
            </div>
          </div>
        </a>
      `
      })      
      resultContainer.innerHTML = searchResult;
      close.classList.add('-active');
      ReactiveSearch.updatePrices();
      search.classList.add('-active');
      search.classList.remove('-loading');
    } else {
      search.classList.remove('-active');
      search.classList.remove('-loading');
      close.classList.remove('-active');
      resultContainer.innerHTML = "";
    }
  },

  closeSearch: function() {
    const close = document.querySelector('[data-close-reactive-search]');
    const search = document.querySelector('[data-reactive-search]');

    if(!search) return;

    close.addEventListener('click', () => {
      close.classList.remove('-active');
      search.classList.remove('-active');
      search.classList.remove('-loading');
    });
  },

  updatePrices: function() {
    const newProducts = document.querySelectorAll('.reactive-search .product-item');
    newProducts.length > 0 && window.Price.init(newProducts);
  },

  init: function(){
    ReactiveSearch.closeSearch();

    const searchInput = document.querySelector('.search-form input');
    if (!searchInput) return;

    searchInput.addEventListener('input', (e)=>{
      let inputEevent = e;
      clearTimeout(ReactiveSearch.timeoutId);

      ReactiveSearch.timeoutId = setTimeout(async () => {
        let value = inputEevent.target.value;
        ReactiveSearch.handleAutocomplete(value);
      }, 1500);
    })
  }
}
  
export default ReactiveSearch;
